module.exports = __webpack_public_path__ + "static/img/image_01@2x.3a2050c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/KtbTrio/image_01@2x.png
// module id = 8zXi
// module chunks = 70